import { IUserContext } from '@truckdown/systems';

export type { AddressModel } from './AddressModel';
export type { ContactModel } from './ContactModel';
export { Currency } from './Currency';
export type { DateRange } from './DateRange';
export { InvoiceFormat } from './InvoiceFormat';
export { PaymentMethod } from './PaymentMethod';
export type { RenewalDate } from './RenewalDate';
export type { ListResultModel } from './ListResultModel'

import { IBillingService } from './IBillingService';
export type { IBillingService };

export type { BillingPreferenceModel } from './BillingPreferenceModel';
export type { BillingSummaryModel } from './BillingSummaryModel';
export type { EditBillingPreferenceModel } from './EditBillingPreferenceModel';
export type { PricesModel } from './PricesModel';
export type { DiscountModel } from './DiscountModel';
export type { PromotionModel } from './PromotionModel';
export type { PromotionRateModel } from './PromotionRateModel';
export type { SalesModel } from './SalesModel';
export type { SalesQueryModel } from './SalesQueryModel';

export type { AddCreditCardModel } from './CreditCards/AddCreditCardModel';
export type { EditCreditCardModel } from './CreditCards/EditCreditCardModel';
export type { CreditCardModel } from './CreditCards/CreditCardModel';
export type { CreditCardQueryOptions } from './CreditCards/CreditCardQueryOptions';
export type { CreditCardResponse } from './CreditCards/CreditCardResponse';
export { CreditCardStatus } from './CreditCards/CreditCardStatus';
export { CreditCardType } from './CreditCards/CreditCardType';
export type { UpdateExpiryModel } from './CreditCards/UpdateExpiryModel';

import { ICreditCardService } from './CreditCards/ICreditCardService';
export type { ICreditCardService };

export type { AddInvoiceModel } from './Invoicing/AddInvoiceModel';
export type { AllocationModel } from './Invoicing/AllocationModel';
export type { EditInvoiceLineItemModel } from './Invoicing/EditInvoiceLineItemModel';
export type { EditInvoiceModel } from './Invoicing/EditInvoiceModel';
export type { InvoiceLineModel } from './Invoicing/InvoiceLineModel';
export type { InvoiceModel } from './Invoicing/InvoiceModel';
export type { InvoiceQueryOptions } from './Invoicing/InvoiceQueryOptions';
export { InvoiceQuerySort } from './Invoicing/InvoiceQuerySort';
export { InvoiceStatus } from './Invoicing/InvoiceStatus';
export { InvoiceTerm } from './Invoicing/InvoiceTerm';
export type { FileInformation } from './Invoicing/FileInformation';

import { IInvoiceQueryService } from './Invoicing/IInvoiceQueryService';
export type { IInvoiceQueryService };

import { IInvoiceGenerator } from './Invoicing/IInvoiceGenerator';
export type { IInvoiceGenerator };

import { IInvoiceManager } from './Invoicing/IInvoiceManager';
export type { IInvoiceManager };

export type { ManualPaymentRequest } from './Payments/ManualPaymentRequest';
export type { ManualRefundRequest } from './Payments/ManualRefundRequest';
export type { PaymentAllocation } from './Payments/PaymentAllocation';
export type { PaymentModel } from './Payments/PaymentModel';
export type { PaymentQueryOptions } from './Payments/PaymentQueryOptions';
export { PaymentStatus } from './Payments/PaymentStatus';
export type { PaymentTransactionModel } from './Payments/PaymentTransactionModel';
export { PaymentTransactionStatus } from './Payments/PaymentTransactionStatus';
export { PaymentTransactionType } from './Payments/PaymentTransactionType';
export type { PreauthPaymentRequest } from './Payments/PreauthPaymentRequest';
export type { ReceiptModel } from './Payments/ReceiptModel';
export type { RefundPaymentRequest } from './Payments/RefundPaymentRequest';
export type { SubmitPaymentRequest } from './Payments/SubmitPaymentRequest';
export type { PaymentTotalModel } from './Payments/PaymentTotalModel';
export type { PaymentSummaryModel } from './Payments/PaymentSummaryModel';

import { IPaymentQueryService } from './Payments/IPaymentQueryService';
export type { IPaymentQueryService };

import { IPaymentService } from './Payments/IPaymentService';
export type { IPaymentService };

import { ISubscriptionQueryService } from './Subscriptions/ISubscriptionQueryService';
export type { ISubscriptionQueryService };
export type { SubscriptionSummaryModel } from './Subscriptions/SubscriptionSummaryModel';
export type { SubscriptionCountModel } from './Subscriptions/SubscriptionCountModel';
export { SubscriptionStatus } from './Subscriptions/SubscriptionStatus';
export { SubscriptionType } from './Subscriptions/SubscriptionType';
export { BillingPeriod } from './Subscriptions/BillingPeriod';
export { SubscriptionScope } from './Subscriptions/SubscriptionScope';
export type { SubscriptionQueryOptions } from './Subscriptions/SubscriptionQueryOptions'
export type { SubscriptionModel } from './Subscriptions/SubscriptionModel'
export type { PaymentSchedule } from './Subscriptions/PaymentSchedule'
export type { SubscriptionGetPausedOptions } from './Subscriptions/SubscriptionGetPausedOptions'

import { ISubscriptionManager } from './Subscriptions/ISubscriptionManager';
import { ISubscriptionCreator } from './Subscriptions/ISubscriptionCreator';
export type { CalculatedServicesModel } from "./Subscriptions/CalculatedServicesModel";
export type { GetCalculatedServicesModel } from "./Subscriptions/GetCalculatedServicesModel";
export type { CancelSubscriptionAccountModel } from './Subscriptions/CancelSubscriptionAccountModel'
export type { CancelSubscriptionBase } from './Subscriptions/CancelSubscriptionBase'
export type { CancelSubscriptionModel } from './Subscriptions/CancelSubscriptionModel'
export type { CancelSubscriptionsModel } from './Subscriptions/CancelSubscriptionsModel'
export type { CancelSubscriptionResultModel } from './Subscriptions/CancelSubscriptionResultModel'
export type { CancelSubscriptionsResultModel } from './Subscriptions/CancelSubscriptionsResultModel'

export type { TrialSubscriptionModel } from './Subscriptions/TrialSubscriptionModel'
export type { CreateSubscriptionAccountModel } from './Subscriptions/CreateSubscriptionAccountModel'
export type { CreateSubscriptionModel } from './Subscriptions/CreateSubscriptionModel'
export type { CreateSubscriptionResultModel } from './Subscriptions/CreateSubscriptionResultModel'
export type { EditSubscriptionBase } from './Subscriptions/EditSubscriptionBase'
export type { EditSubscriptionModel } from './Subscriptions/EditSubscriptionModel'
export type { EditSubscriptionsModel } from './Subscriptions/EditSubscriptionsModel'
export type { RenewResultModel } from './Subscriptions/RenewResultModel'
export type { EditSubscriptionServicesModel } from './Subscriptions/EditSubscriptionServicesModel'
export type { EditSubscriptionsServicesModel } from './Subscriptions/EditSubscriptionsServicesModel'

export type { ISubscriptionManager };
export type { ISubscriptionCreator };

export default function (context: IUserContext): void {
    context.registerService({
        name: 'IBillingService',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-billing-service" */ './BillingService');
            return new svc.BillingService(context) as IBillingService;
        }
    });

    context.registerService({
        name: 'ICreditCardService',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-billing-cc-service" */ './CreditCards/CreditCardService');
            return new svc.CreditCardService(context) as ICreditCardService;
        }
    });

    context.registerService({
        name: 'IInvoiceQueryService',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-billing-invoice-query-service" */ './Invoicing/InvoiceQueryService');
            return new svc.InvoiceQueryService(context) as IInvoiceQueryService;
        }
    });

    context.registerService({
        name: 'IInvoiceGenerator',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-billing-invoice-generator" */ './Invoicing/InvoiceGenerator');
            return new svc.InvoiceGenerator(context) as IInvoiceGenerator;
        }
    });

    context.registerService({
        name: 'IInvoiceManager',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-billing-invoice-manager" */ './Invoicing/InvoiceManager');
            return new svc.InvoiceManager(context) as IInvoiceManager;
        }
    });

    context.registerService({
        name: 'IPaymentQueryService',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-billing-payment-query-service" */ './Payments/PaymentQueryService');
            return new svc.PaymentQueryService(context) as IPaymentQueryService;
        }
    });

    context.registerService({
        name: 'IPaymentService',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-billing-payment-service" */ './Payments/PaymentService');
            return new svc.PaymentService(context) as IPaymentService;
        }
    });

    context.registerService({
        name: 'ISubscriptionQueryService',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-billing-subscription-query-service" */ './Subscriptions/SubscriptionQueryService');
            return new svc.SubscriptionQueryService(context) as ISubscriptionQueryService;
        }
    });

    context.registerService({
        name: 'ISubscriptionManager',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-billing-subscription-manager" */ './Subscriptions/SubscriptionManager');
            return new svc.SubscriptionManager(context) as ISubscriptionManager;
        }
    });

    context.registerService({
        name: 'ISubscriptionCreator',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-billing-subscription-creator" */ './Subscriptions/SubscriptionCreator');
            return new svc.SubscriptionCreator(context) as ISubscriptionCreator;
        }
    });
}
